import { Draft } from '@reduxjs/toolkit';

import { IAuthData } from '../../index';

function changePasswordFailure(draft: Draft<IAuthData>) {
  draft.changePassword.config.isLoading = false;
}

export default changePasswordFailure;
